var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cs from '../_util/classNames';
import Trigger from '../Trigger';
import { ConfigConsumer } from '../ConfigProvider';
var positions = [
    'top',
    'tl',
    'tr',
    'bottom',
    'bl',
    'br',
    'left',
    'lt',
    'lb',
    'right',
    'rt',
    'rb',
];
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderPopup = function (prefixCls) {
            var _a = _this.props, content = _a.content, position = _a.position;
            var classNames = cs(prefixCls + "-content", prefixCls + "-content-" + position);
            return (React.createElement("div", { className: classNames },
                React.createElement("div", { className: prefixCls + "-content-inner" }, typeof content === 'function' ? content() : content)));
        };
        _this.updatePopupPosition = function (delay, callback) {
            if (delay === void 0) { delay = 0; }
            _this.refTrigger && _this.refTrigger.updatePopupPosition(delay, callback);
        };
        _this.renderTooltip = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, style = _b.style, className = _b.className, children = _b.children, trigger = _b.trigger, position = _b.position, unmountOnExit = _b.unmountOnExit, popupVisible = _b.popupVisible, tooltipPrefixCls = _b.prefixCls, blurToHide = _b.blurToHide, popupHoverStay = _b.popupHoverStay, disabled = _b.disabled, onVisibleChange = _b.onVisibleChange, triggerProps = _b.triggerProps, childrenPrefix = _b.childrenPrefix, getPopupContainer = _b.getPopupContainer;
            var otherProps = __assign({}, triggerProps);
            if (onVisibleChange) {
                otherProps.onVisibleChange = onVisibleChange;
            }
            if (childrenPrefix) {
                otherProps.childrenPrefix = childrenPrefix;
            }
            var prefixCls = tooltipPrefixCls || getPrefixCls('tooltip');
            return (React.createElement(Trigger, __assign({ style: __assign({ maxWidth: 350 }, style), className: className, ref: function (ref) { return (_this.refTrigger = ref); }, classNames: "zoomTooltip", popup: _this.renderPopup.bind(_this, prefixCls), position: position, disabled: disabled, trigger: trigger, showArrow: true, popupAlign: {
                    left: 12,
                    right: 12,
                    top: 12,
                    bottom: 12,
                }, mouseEnterDelay: 200, mouseLeaveDelay: 200, unmountOnExit: unmountOnExit, popupVisible: popupVisible, popupHoverStay: popupHoverStay, blurToHide: blurToHide, childrenPrefix: prefixCls, getPopupContainer: getPopupContainer }, otherProps), children));
        };
        return _this;
    }
    Tooltip.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderTooltip);
    };
    Tooltip.displayName = 'Tooltip';
    Tooltip.propTypes = {
        style: PropTypes.object,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        content: PropTypes.any.isRequired,
        getPopupContainer: PropTypes.func,
        position: PropTypes.oneOf(positions),
        trigger: PropTypes.oneOf(['hover', 'click', 'focus', 'manual']),
        prefixCls: PropTypes.string,
        unmountOnExit: PropTypes.bool,
        popupVisible: PropTypes.bool,
        onVisibleChange: PropTypes.func,
        blurToHide: PropTypes.bool,
        popupHoverStay: PropTypes.bool,
        disabled: PropTypes.bool,
        triggerProps: PropTypes.object,
        childrenPrefix: PropTypes.string,
    };
    Tooltip.defaultProps = {
        style: {},
        position: 'top',
        trigger: 'hover',
        unmountOnExit: true,
        blurToHide: true,
        popupHoverStay: false,
        triggerProps: {},
    };
    return Tooltip;
}(PureComponent));
export default Tooltip;
